import { getClass } from '../utils/object-utils.js';

const DESIGN_PARAM_TYPES = 'design:paramtypes';
const DESIGN_TYPE = 'design:type';
const DESIGN_RETURN_TYPE = 'design:returntype';
const PROPERTIES = new Map();
/**
 * 用于管理 Metadata 的静态工具类
 * @public
 */
class Metadata {
    static set(key, value, target, propertyKey) {
        const targets = PROPERTIES.has(key) ? PROPERTIES.get(key) : [];
        const classConstructor = getClass(target);
        if (!targets.includes(classConstructor)) {
            targets.push(classConstructor);
            PROPERTIES.set(key, targets);
        }
        Reflect.defineMetadata(key, value, getClass(target), propertyKey);
    }
    static getParamTypes(target, propertyKey) {
        var _a;
        return (_a = Reflect.getMetadata(DESIGN_PARAM_TYPES, target, propertyKey)) !== null && _a !== void 0 ? _a : [];
    }
    static setParamTypes(target, propertyKey, value) {
        return this.set(DESIGN_PARAM_TYPES, value, getClass(target).prototype, propertyKey);
    }
    static getOwn(key, target, propertyKey) {
        return Reflect.getOwnMetadata(key, getClass(target), propertyKey);
    }
    static hasOwn(key, target, propertyKey) {
        return Reflect.hasOwnMetadata(key, getClass(target), propertyKey);
    }
}
Metadata.get = (key, target, propertyKey) => Reflect.getMetadata(key, getClass(target), propertyKey);
Metadata.getType = (target, propertyKey) => Reflect.getMetadata(DESIGN_TYPE, target, propertyKey);
Metadata.setType = (target, propertyKey, value) => Reflect.defineMetadata(DESIGN_TYPE, value, target, propertyKey);
Metadata.getReturnType = (target, propertyKey) => Reflect.getMetadata(DESIGN_RETURN_TYPE, target, propertyKey);
Metadata.has = (key, target, propertyKey) => Reflect.hasMetadata(key, getClass(target), propertyKey);
Metadata.getTargetsFromPropertyKey = (metadataKey) => (PROPERTIES.has(metadataKey) ? PROPERTIES.get(metadataKey) : []);

export { Metadata };
//# sourceMappingURL=metadata.js.map
